'use strict';

const h = require('phy');

const selectUserComponent = props => {
  return h('div', {
    dangerouslySetInnerHTML: {
      __html: props.promoCodeV2SelectHtml,
    },
  });
};

module.exports = selectUserComponent;
